import React from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { ResizeHandle } from "components/icons/assortments/resize-handle";
import "./grid-split.css";

interface Props {
    children: React.ReactNode;
    isGridOpen?: boolean;
    financialTargetGrid: React.ReactNode;
    shouldRenderTargetsGrid: boolean;
}

export const GridSplit = ({ children, isGridOpen, financialTargetGrid, shouldRenderTargetsGrid }: Props) => {
    if (!shouldRenderTargetsGrid) {
        return <>{children}</>;
    }

    return (
        <PanelGroup direction="vertical">
            <Panel defaultSize={50} minSize={25}>
                {children}
            </Panel>

            {isGridOpen && (
                <>
                    <PanelResizeHandle>
                        <div className="collection__grid-split-resize-handle">
                            <ResizeHandle />
                        </div>
                    </PanelResizeHandle>
                    <Panel defaultSize={50} minSize={5}>
                        {financialTargetGrid}
                    </Panel>
                </>
            )}
        </PanelGroup>
    );
};
